import { SelectModified } from "components/SelectModified"
import { TablePagination } from "./styles";

interface TableModifiedPaginationProps {
  totalItemsCount?:number,
  rowsPerPage?: number,
  pageNumber?: number,
  onRowsPerPageChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void,
  onPageSelected?: (pageNumber: number) => void,
}

interface RowsPerPageProps {
  label:string,
  value:string,
}

interface PageButtonProps {
  pageNumber: number,
  isActive?: boolean,
  onClick?: (pageNumber:number) => void,
}


interface PagesProps {
  currentPage: number,
  totalPages: number,
  onPageSelected?: (pageNumber:number) => void,
}

const PageButton:React.FC<PageButtonProps> = ({
  pageNumber,
  isActive = false,
  onClick
}) => {
  return (
    <button 
      type="button"
      className={`button-paginate ${isActive ? 'isActive' : ''}`}
      name="pageSelect"
      value={pageNumber}
      disabled={isActive}
      onClick={() => onClick?.(pageNumber)}
    >
      {pageNumber}
    </button>
  )
}

const Pages:React.FC<PagesProps> = ({currentPage, totalPages, onPageSelected}) => {
  var pages = [];
  var firstPage = currentPage <= 3 ? 1 : currentPage > totalPages-3 ? totalPages-3 : currentPage-2;
  var lastPage = currentPage > totalPages-3 ? totalPages : currentPage < 3 ? (totalPages < 5 ? totalPages : 5) : currentPage+2;

  if (firstPage !== 1) {
    pages.push(
      <>
        <PageButton
          key={1}
          pageNumber={1}
          onClick={onPageSelected}
        />
        <span className="paginate-dot">
          <strong>...</strong>
        </span>
      </>
    );
  }

  for(let i = firstPage; i <= lastPage; ++i) {
    pages.push(
      <PageButton
        key={i}
        pageNumber={i}
        isActive={i === currentPage}
        onClick={onPageSelected}
      />
    );
  }

  if (lastPage !== totalPages) {
    pages.push(
      <>
        <span className="paginate-dot">
          <strong>...</strong>
        </span>
        <PageButton
          key={totalPages}
          pageNumber={totalPages}
          onClick={onPageSelected}
        />
      </>
    )
  }
  return <div className="paginate">{pages}</div>;
}

const rowsPerPageOptions:RowsPerPageProps[] = [
  {label: '10', value: '10'},
  {label: '30', value: '30'},
  {label: '90', value: '90'},
]

export const TableModifiedPagination:React.FC<TableModifiedPaginationProps> = ({
  totalItemsCount,
  rowsPerPage=10,
  pageNumber=1,
  onRowsPerPageChange,
  onPageSelected,
}) => {
  const totalPages = Math.ceil((totalItemsCount ?? 0)/rowsPerPage);

  return (
    <TablePagination>
      <div className="total-itens">
        <strong className="tag">Exibindo:</strong>
        <SelectModified
          name="RowsPerPage"
          appearWhere={"top"}
          label={''}
          value={rowsPerPage.toString()}
          block={true}
          options={rowsPerPageOptions}
          onChange={onRowsPerPageChange}
          size="small"
        />
        <Pages
          key={pageNumber}
          currentPage={pageNumber}
          totalPages={totalPages}
          onPageSelected={onPageSelected}
        />
      </div>
    </TablePagination>
  )
}